import React, { useState } from 'react';
import FullscreenChartPage from './Page/FullscreenChartPage';
import LoadingState from './components/ChartCapture/LoadingState';
import './ind.css';

export default function App() {
  const [allData, setAllData] = useState([]); 
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasInitialLoad, setHasInitialLoad] = useState(false); 

  const fetchSymbolData = async (symbol, timeframe = "1") => {
    try {
      console.log(` Fetching data for ${symbol} with timeframe ${timeframe}...`);
      
      const apiUrl = window.config?.base_api_url 
        ? `${window.config.base_api_url}/api/setflow?symbol=${symbol}&timeframe=${timeframe}`
        : `/api/setflow?symbol=${symbol}&timeframe=${timeframe}`;
      
      console.log(' API URL:', apiUrl);
      
      const headers = {
        'Content-Type': 'application/json',
      };
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: headers,
      });

      console.log(' Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(' Error response:', errorText);
        throw new Error(`Failed to fetch ${symbol}: ${response.status}`);
      }

      const result = await response.json();
      console.log(' Response:', result);
      
      if (result && result.data && Array.isArray(result.data)) {
        console.log(` ${symbol}: ${result.data.length} records`);
        
        if (result.data.length > 0) {
          console.log(' Sample data:', result.data[0]);
        }
        
        const processedData = result.data.map(record => ({
          ...record,
          symbol: result.symbol || symbol,
          timeframe: result.timeframe || timeframe,
        }));
        
        setHasInitialLoad(true); 
        return processedData;
      }
      
      console.warn(` No data for ${symbol}`);
      setHasInitialLoad(true);
      return [];
    } catch (error) {
      console.error(` Error fetching ${symbol}:`, error);
      throw error;
    }
  };


  if (isLoading) {
    return (
      <div className="app-loading fixed inset-0 bg-dark-primary flex items-center justify-center">
        <LoadingState message="Loading flow data..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="fixed inset-0 bg-dark-primary flex items-center justify-center p-8">
        <div className="max-w-xl w-full bg-gray-800 rounded-lg p-6 text-white text-center">
          <div className="text-red-500 text-2xl font-bold mb-4">⚠ Error</div>
          <div className="mb-4 p-4 bg-red-900/30 rounded">
            <p className="font-mono text-sm">{error}</p>
          </div>
          <button 
            onClick={() => window.location.reload()} 
            className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            ลองใหม่
          </button>
        </div>
      </div>
    );
  }

  console.log(' Rendering chart with', allData.length, 'records');
  
  return <FullscreenChartPage data={allData} onFetchSymbol={fetchSymbolData} />;
}